export const environment = {
  production: false,

  KC_URL:'https://dev-auth.pjm.gob.ar/auth/',
  KC_CLIENT_ID:'skipper',
  KC_REALMS: [
    { id: 'devops', name: 'Usuario Judicial' },
    { id: 'profesionales', name: 'Profesionales Registrados' },

  ],
  BACK_CONSULTA:"https://dev-backend.pjm.gob.ar/skipper-download/cpl/",
  BACK_DOWNLOADER:"https://dev-backend.pjm.gob.ar/skipper-fix-downloader-master/api/v1.0/download-document/",
  BACK_VIDEO_URL:"https://dev-backend.pjm.gob.ar/skipper-fix-downloader-master/api/v1.0/download-video/"
};
// BACK_INITIAL:"https://dev-backend.pjm.gob.ar/skipper-initial-master/api/v1.0/initial/",
